export default {
  colors: {
    "chakra-body-text": { _light: "base.600", _dark: "whiteAlpha.900" },
    "chakra-body-bg": { _light: "base.50", _dark: "base.700" },
  },
};
